import { useWatch } from '@0g/react';
import * as React from 'react';
import { Field, FieldInput, FieldLabel, FieldInputGroup, FieldCurrentValue, } from '../components/Field';
import { useId } from '../hooks/useId';
export function NumberField(_a) {
    var store = _a.store, name = _a.name;
    var id = useId();
    var ref = React.useRef(null);
    var onChange = React.useCallback(function (ev) {
        store[name] = ev.target.value;
        store.updated = true;
    }, [store, name]);
    useWatch(store, React.useCallback(function () {
        if (!ref.current)
            return;
        ref.current.innerText = store[name];
    }, [store, name, ref]));
    return (React.createElement(Field, null,
        React.createElement(FieldLabel, { htmlFor: id }, name),
        React.createElement(FieldInputGroup, null,
            React.createElement(FieldCurrentValue, { ref: ref }),
            React.createElement(FieldInput, { onBlur: onChange, id: id, type: "number" }))));
}
//# sourceMappingURL=NumberField.js.map